import mushodoPromise from '@webapp-next/lib/request/webapp/mushodo-promise';

export default async function mushodoCheckStatusBackgroundJob(syncKey) {
  try {
    const result = await mushodoPromise('PollTeamParallelCompletion', syncKey);
    return {
      success: true,
      message: '',
      result,
    };
  } catch (e) {
    throw e;
  }
}
